import { Highlight } from '@components/highlight/highlight';
import { useLiteStorefront } from '@hooks/use-lite-storefront';
import { useTrackStorefrontImpression } from '@hooks/useTrackStorefrontImpression';
import { useTrackStorefrontInteraction } from '@hooks/useTrackStorefrontInteraction';
import { useAtomValue } from 'jotai';
import React, { useCallback, useMemo } from 'react';
import { Link } from 'react-scroll';
import {
	guestCapacityAtom,
	guestCapacityMaxAtom,
	startingCostAtom,
} from '../../../jotai/storefront/pricing';
import Styles from './price-and-guests-highlights.styles.scss';

const PriceAndGuestsHighlights = () => {
	const impressionRef = useTrackStorefrontImpression(
		'Venue Pricing Highlights',
	);
	const guestCapacity = useAtomValue(guestCapacityAtom);
	const guestCapacityMax = useAtomValue(guestCapacityMaxAtom);
	const priceHeaderText = useAtomValue(startingCostAtom);
	const trackSeeDetails = useTrackStorefrontInteraction('content highlights');
	const handleSeeDetails = useCallback(() => {
		trackSeeDetails('See details');
	}, [trackSeeDetails]);
	const isLiteStorefront = useLiteStorefront();

	const guestCapacityText = useMemo(() => {
		switch (guestCapacityMax?.trim()) {
			case '300+':
				return `This venue can host ${guestCapacityMax} guests`;
			case '50':
				return 'Actual capacity may vary';
			default:
				return `This venue can host up to ${guestCapacityMax} guests`;
		}
	}, [guestCapacityMax]);

	if (!guestCapacity && !priceHeaderText) return null;

	return (
		<div className={Styles.highlights} ref={impressionRef}>
			{priceHeaderText && (
				<>
					<meta
						itemProp="priceRange"
						content={`${priceHeaderText}+`}
						data-testid="meta-price-range"
					/>
					<Highlight
						iconName="dollar-circle"
						highlightTitle={`${priceHeaderText} starting price`}
						highlightText={
							!isLiteStorefront ? (
								<Link
									href={'#navPricing'}
									onClick={handleSeeDetails}
									to="navPricing"
									smooth
									spy
									isDynamic
									offset={-49}
								>
									See details
								</Link>
							) : null
						}
					/>
				</>
			)}

			{guestCapacity && (
				<Highlight
					iconName="group"
					highlightTitle={`${guestCapacity} guest capacity`}
					highlightText={guestCapacityText}
				/>
			)}
		</div>
	);
};

export { PriceAndGuestsHighlights };
